import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function TopContributorStandingsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.TopContributorStandings', {
		url: '/users/top_contributors',
		controllerAs: 'vm',
		controller: TopContributorStandingsCtrl,
		templateUrl: '/ng/hub/TopContributors/Standings/TopContributorStandingsCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/TopContributors/Standings/TopContributorStandingsCtrl.css'),
			$title: () => 'Top Contributor Standings',
			contributors: ApiResourcify.endpoint('/users/top_contributors?limit=10'),
		},
	});
}

export class TopContributorStandingsCtrl {
	constructor(Cfg, contributors, Identity) {
		'ngInject';
		this.hub = Identity.currentClient();
		this.contributors = contributors;
		this.hideLikesAndComments = Cfg.read('Features.hide_likes_and_comments') !== '0';
	}
}
